import hrApi from '@/api/v1/hr';

export default {
  namespaced: true,

  state: {
    featuresData: {},
    featuresFilters: [],
  },

  mutations: {
    CHANGE_FEATURES_DATA(state, featuresData) {
      const newParam = {};
      featuresData.forEach((item) => {
        newParam[item.slug] = item.features;
      });

      state.featuresData = newParam;
    },

    CHANGE_FEATURES(state, features) {
      state.featuresFilters = features;
    },
  },

  actions: {
    fetchFeaturesData({ commit }) {
      return new Promise((resolve, reject) => {
        hrApi.features
          .index()
          .then((resp) => {
            commit('CHANGE_FEATURES_DATA', resp.data);
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },

    fetchFeatures({ commit }) {
      hrApi.filters
        .index()
        .then((resp) => {
          commit('CHANGE_FEATURES', resp.data);
        })
        .catch(() => {
        });
    },
  },
};
